import { WhatsappBotMenuNode, WhatsappBotMenuOption } from "./whatsappBot.model";

// Funções puras de navegação/validação sobre a árvore do bot de WhatsApp —
// cópia adaptada de ivrMenu.utils.ts (mesmo princípio, tipos diferentes).
// Não fazem I/O — quem chama decide onde persistir.

export function emptyMenuNode(): WhatsappBotMenuNode {
  return { message: "", options: [] };
}

export function findMenuNode(
  root: WhatsappBotMenuNode,
  path: number[]
): WhatsappBotMenuNode {
  let node = root;
  for (const digit of path) {
    const opt = node.options.find((o) => o.option === digit);
    if (!opt || opt.type !== "submenu") {
      throw new Error(`Caminho inválido: a tecla ${digit} não leva a um submenu`);
    }
    node = opt.node;
  }
  return node;
}

export type MenuBreadcrumb = { label: string; path: number[] };

export function buildMenuBreadcrumbs(
  root: WhatsappBotMenuNode,
  path: number[]
): MenuBreadcrumb[] {
  const crumbs: MenuBreadcrumb[] = [{ label: "Menu principal", path: [] }];
  let node = root;
  const acc: number[] = [];
  for (const digit of path) {
    const opt = node.options.find((o) => o.option === digit);
    if (!opt || opt.type !== "submenu") break;
    acc.push(digit);
    crumbs.push({ label: `${digit} · ${opt.name}`, path: [...acc] });
    node = opt.node;
  }
  return crumbs;
}

// Próxima tecla livre (0-9) num nível, ou null se as 10 já estão em uso.
export function nextAvailableDigit(options: WhatsappBotMenuOption[]): number | null {
  const used = new Set(options.map((o) => o.option));
  for (let d = 1; d <= 9; d++) if (!used.has(d)) return d;
  if (!used.has(0)) return 0;
  return null;
}

// currentDigit: a tecla que a opção já tinha antes da edição, pra não
// acusar colisão dela consigo mesma ao editar sem trocar de tecla.
export function isDigitAvailable(
  options: WhatsappBotMenuOption[],
  digit: number,
  currentDigit?: number
): boolean {
  return !options.some((o) => o.option === digit && o.option !== currentDigit);
}

// Substitui o nó em `path` pelo retorno de `updater(nó atual)`, clonando só
// os nós no caminho (o resto da árvore é reaproveitado).
export function updateNodeAtPath(
  root: WhatsappBotMenuNode,
  path: number[],
  updater: (node: WhatsappBotMenuNode) => WhatsappBotMenuNode
): WhatsappBotMenuNode {
  if (path.length === 0) return updater(root);
  const [digit, ...rest] = path;
  return {
    ...root,
    options: root.options.map((o) => {
      if (o.option !== digit || o.type !== "submenu") return o;
      return { ...o, node: updateNodeAtPath(o.node, rest, updater) };
    }),
  };
}
